module.exports = __webpack_public_path__ + "static/img/joinus.5a054ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/join/joinus.jpg
// module id = oSb+
// module chunks = 0